export default __webpack_public_path__ + "static/media/cloudsql.480340df.svg";